export const splitQuery = (query: string): Array<string> => {
    return [...new Set(query
        .replaceAll(/(?:\n)/g, ' ')
        .replaceAll(/(?:\t)/g, ' ')
        .replaceAll(/(?:\r)/g, ' ')
        .replaceAll(';', ' ')
        .replaceAll(',', ' ')
        .split(' ')
        .map(e => e.trim())
        .filter(e => e.length),
    )];
};
